export default "__VITE_ASSET__aTEEP2bmmlT0KAXNdGI82g__";